import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-order-line-credit-cause',
  templateUrl: './order-line-credit-cause.component.html',
  styleUrls: ['./order-line-credit-cause.component.css']
})
export class OrderLineCreditCauseComponent implements OnInit {
    orderLineCauseKeyno;

    public edit?: Edit;

    public orderLineCreditCauseLangNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderlinecreditcauselang', gotoParms: () => this.edit?.orderlinecreditcause_keyno ?? '' }];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderLineCauseKeyno = this.stateService.getStateParams()['orderlinecreditcause_keyno'];
    }

    private async loadEdit() {
        if (!!this.orderLineCauseKeyno) {
            this.edit = (await this.datatask.Post(2761, { orderlinecreditcause_keyno: this.orderLineCauseKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2763, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    orderlinecreditcause_keyno: string;
    orderlinecreditcauselang_name: string;
    orderlinecreditcause_description_required: number;
    orderlinecreditcause_picture_required: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCreditCause', {
//        templateUrl: 'views/components/views/orderLineCreditCause/orderLineCreditCause.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'orderLineCreditCauseService', 'translateService', function ($stateParams, stateService, modalService, orderLineCreditCauseService, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCauseKeyno = $stateParams.orderlinecreditcause_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                orderLineCreditCauseLangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderlinecreditcauselang', { orderlinecreditcause_keyno: vm.model.edit.orderlinecreditcause_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await orderLineCreditCauseService.getOrderLineCreditCause({ orderlinecreditcause_keyno: orderLineCauseKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCreditCauseService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
